<template>
  <div>
    <b-row>
      <!-- banco -->
      <b-col sm="4" v-show="showComboBanco">
        <b-form-group label="Banco">
          <input-select
            v-model="model.banco"
            @input="loadComboParceiros"
            :options="bancos"
            single
            :required="bancoRequired"
          />
        </b-form-group>
      </b-col>

      <!-- parceiro -->
      <b-col :sm="!showComboBanco ? '5' : '3'">
        <b-form-group
          :label="titleComboParceiro ? titleComboParceiro : 'Parceiro'"
        >
          <input-select
            v-model="model.parceiro"
            :options="parceiros"
            :disabled="!model.banco"
            :placeholder="placeholderParceiro"
            single
            :required="parceiroRequired"
          />
        </b-form-group>
      </b-col>

      <slot name="middleBtns"></slot>

      <!-- agencia -->
      <b-col sm="3" v-show="showAgenciaConta">
        <b-form-group label="Agência">
          <input-select
            v-model="model.agencia"
            @input="changeAgencia"
            :options="agencias"
            :placeholder="placeholderAgencia"
            :disabled="!model.parceiro || !model.banco"
            single
            :required="agenciaRequired"
          />
        </b-form-group>
      </b-col>
      <!-- conta -->
      <b-col :sm="2" v-show="showConta">
        <b-form-group 
          :label="titleComboConta ? titleComboConta : 'Conta'">
          <input-select
            v-model="model.contaCombo"
            :search="pesquisaConta"
            :options="contas"
            :placeholder= "placeholderConta"
            :disabled="(!model.agencia && disableConta) || (!model.parceiro && disableConta)"
            :required="contaRequired"
          />
        </b-form-group>
      </b-col>

      <b-col sm="2" v-show="showTipoQRCode">
        <b-form-group label="Tipo QRCode">
          <input-select
            v-model="model.tipoQRCode"
            placeholder="Todos"
            :options="$api.Arrays.TipoQRCodeDinamico.filter(el => el.text != 'Todos')"
            :disabled="!model.agencia || !model.parceiro || !model.contaCombo"
          />
        </b-form-group>
      </b-col>
      <slot name="extraBtns"></slot>
    </b-row>

    <b-row v-if="showInfoCorrentista">
      <b-col sm="6">
        <b-form-group label="Cliente">
          <b-input v-model="modelCorrentista.nome" :disabled="true" />
        </b-form-group>
      </b-col>

      <b-col sm="3">
        <b-form-group label="Documento Federal">
          <input-documento
            v-model="modelCorrentista.documentoFederal"
            :disabled="true"
          />
        </b-form-group>
      </b-col>

      <b-col sm="2">
        <b-form-group label="Tipo Pessoa">
          <b-form-select
            v-model="modelCorrentista.tipoPessoa"
            :options="$api.Arrays.TiposPessoa"
            :disabled="true"
          />
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
        <!-- data inicial -->
        <b-col sm="3" v-if="showData && showDataInicial">
            <b-form-group :label="dtIniText">
                <kendo-datepicker v-model="model.dtInicio"
                                  :max="dtMax"
                                  v-mask="'##/##/####'"
                                  :format="'dd/MM/yyyy'"
                                  :required="requiredData && dataInicialRequired"></kendo-datepicker>
            </b-form-group>
        </b-col>
        <!-- data final -->
        <b-col sm="3" v-if="showData && showDataFinal">
            <b-form-group :label="dtFimText">
                <kendo-datepicker v-model="model.dtFim"
                                  :min="dtMin"
                                  :max="new Date()"
                                  v-mask="'##/##/####'"
                                  :format="'dd/MM/yyyy'"
                                  :required="requiredData && dataFinalRequired"></kendo-datepicker>
            </b-form-group>
        </b-col>

        <b-col sm="3" v-if="showDataBase">
            <b-form-group label="Data Base">
                <input-date v-model="model.dtBase"></input-date>
            </b-form-group>
        </b-col>

        <b-col sm="6" v-if="comboOperacoes">
            <b-form-group label="Operações">
                <input-multiselect v-model="model.operacoes" :options="operacoes" />
            </b-form-group>
        </b-col>

        <b-col sm="3" v-if="comboContaBloqueio">
            <b-form-group label="Situação Bloqueio Conta">
                <input-select v-model="model.situacaoBloqueio"
                              :options="this.$api.Arrays.SituacaoBloqueioConta"
                              single />
            </b-form-group>
        </b-col>

        <b-col sm="3" v-if="comboContaSaldo">
            <b-form-group label="Situação Saldo">
                <input-select v-model="model.situacaoSaldo"
                              :options="this.$api.Arrays.SituacaoSaldoConta"
                              single />
            </b-form-group>
        </b-col>

        <b-col sm="3" v-if="motivoEncerramento">
            <b-form-group label="Motivo Encerramento">
                <input-select v-model="model.motivoEncerramento" :options=" this.$api.Arrays.MotivoEncerramento" single />
            </b-form-group>
        </b-col>

        <b-col sm="3" v-if="situacaoReivindicacaoDoacao">
            <b-form-group label="Situação Portabilidade">
                <input-select v-model="model.situacaoReivindicacaoDoacao" :options=" this.$api.Arrays.SituacoesReivindicacoesDoacoes" single />
            </b-form-group>
        </b-col>

        <b-col sm="3"  v-if="situacaoTarifa">
            <b-form-group label="Situação">
                <input-select v-model="model.situacaoTarifa"
                              :options="$api.Arrays.SituacaoTransacaoDescricao" single :required="requiredSituacaoTarifa"/>
            </b-form-group>
          </b-col>

        <b-col sm="3"  v-if="origemTransacaoPix">
          <b-form-group label="Origem Transação Pix">
              <input-select v-model="model.origemTransacaoPix"
                            :options="optionsOrigemTransacaoPix" single :required="true"/>
          </b-form-group>
        </b-col>
        
        <b-col sm="3"  v-if="razaoDevolucao">
          <b-form-group label="Motivo Devolução">
            <input-select v-model="model.razaoDevolucao"
                          :options="$api.Arrays.RazaoDevolucaoSimplificado" single :required="true"/>
          </b-form-group>
        </b-col>

    </b-row>
    <b-row>
      <b-col sm="3"  v-if="situacaoNotificacaoInfracaoPix">
          <b-form-group label="Situação Notificação">
              <input-select v-model="model.SituacaoNotificacaoInfracaoPix"
                            :options="$api.Arrays.SituacaoNotificacaoInfracaoPix" single :required="false" placeholder="Todos"/>
          </b-form-group>
        </b-col>
        <b-col sm="3"  v-if="situacaoRecuperacaoValores">
          <b-form-group label="Situação Recuperação de Valores">
            <input-select v-model="model.situacaoRecuperacaoValores"
                          :options="$api.Arrays.SituacaoRecuperacaoValores" single :required="false" placeholder="Todos"/>
          </b-form-group>
        </b-col>
      <b-col sm="3"  v-if="camposOrdenacao">
        <b-form-group label="Listar Ordenado pelo Campo">
          <input-select v-model="model.ordenacaoCampo"
                        :options="camposOrdenacao" single/>
        </b-form-group>
      </b-col>
      <b-col sm="3"  v-if="camposOrdenacao">
        <b-form-group label="Listar em Ordem">
          <input-select v-model="model.ordenacaoDirecao"
                        :options="direcoesOrdenacao" single/>
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
    props: {
    showData: { type: Boolean, default: true },
    showDataInicial: { type: Boolean, default: true },
    showDataFinal: { type: Boolean, default: true },
    comboOperacoes: { type: Boolean, default: false },
    showDataBase: { type: Boolean, default: false },
    comboContaBloqueio: { type: Boolean, default: false },
    comboContaSaldo: { type: Boolean, default: false },
    showComboBanco: { type: Boolean, default: true },
    parceiroSelected: { type: Boolean, default: false },
    value: { type: Object },
    dtIniText: { type: String, default: 'Data Inicial' },
    dtFimText: { type: String, default: 'Data Final' },
    requiredData: { type: Boolean, default: true },
    dataInicialRequired: { type: Boolean, default: true },
    dataFinalRequired: { type: Boolean, default: true },
    contaAtivas: { type: Boolean, default: false },
    todosParceiros: { type: Boolean, default: false },
    contaRequired: { type: Boolean, default: true },
    bancoRequired: { type: Boolean, default: true },
    agenciaRequired: { type: Boolean, default: false },
    parceiroRequired: { type: Boolean, default: false },
    titleComboParceiro: { type: String, default: null },
    titleComboConta: { type: String, default: null },
    showInfoCorrentista: { type: Boolean, default: false },
    motivoEncerramento: { type: Boolean, default: false },
    situacaoReivindicacaoDoacao: { type: Boolean, default: false },
    situacaoTarifa: { type: Boolean,default:false},
    operacoesRecorrente: {type:Boolean,default:false},
    autoSelectAgencia: { type: Boolean, default: false },
    requiredSituacaoTarifa: { type: Boolean, default: true },
    origemTransacaoPix: { type: Boolean, default: false },
    showAgenciaConta: { type: Boolean, default: true },
    showConta: { type: Boolean, default: true },
    disableConta: { type: Boolean, default: true },
    numeroAgenciaDefault: { type: String, default: null },
    showTipoQRCode: { type: Boolean, default: false },
    situacaoNotificacaoInfracaoPix: { type: Boolean, default: false },
    placeholderParceiro: { type: String, default: 'Todos' },
    placeholderAgencia: { type: String, default: 'Todas' },
    placeholderConta: { type: String, default: 'Todas' },
    camposOrdenacao: { type: Array, default: null },
    situacaoRecuperacaoValores: { type: Boolean, default: false },
    razaoDevolucao: { type: Boolean, default: false }
  },
  data () {
    return {
      bancos: [],
      agencias: [],
      contas: [],
      parceiros: [],
      operacoes: [],
      modelCorrentista: {},
      direcoesOrdenacao: [
        { value: "desc", text: 'Decrescente' },
        { value: "asc", text: 'Crescente' }       
      ]
    }
  },
  computed: {
    optionsOrigemTransacaoPix: function () {
      var origemTransacoesPixPermitidos = [5, 505]
      return this.$api.Arrays.OrigemTransacao.filter((e) => origemTransacoesPixPermitidos.includes(e.value))
    },
    dtMin: function () {
      return this.model.dtInicio
        ? kendo.parseDate(this.model.dtInicio)
        : new Date('1970-01-01Z00:00:00:000')
    },
    dtMax: function () {
      return this.model.dtFim ? kendo.parseDate(this.model.dtFim) : new Date()
    },
    model: {
      get () {
        var obj = this.value
        return obj
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  },
  watch: {
    'model.contaCombo': function (val) {
      if (val) {
        this.$set(this.model, 'conta', val.value)
        this.$set(this.model, 'contaText', val.text)
      } else {
        this.$set(this.model, 'conta', null)
        this.$set(this.model, 'contaText', null)
      }
      this.changeConta(val)
      this.$emit('refresh')
    },
    'model.parceiro': function (val) {
      if (val) {
        let parceiroText = this.parceiros.find((x) => x.value === val).text
        this.$set(this.model, 'parceiroText', parceiroText)
      } else {
        this.$set(this.model, 'parceiroText', null)
      }
      this.loadComboAgencias(val)
      this.changeParceiro(val)
      this.$emit('refresh')
    },
    'model.agencia': function (val) {
      if (val) {
        let agenciaText = this.agencias.find(x => x.value === val).text
        let agencia = this.agencias.find(x => x.value === val)
        this.$set(this.model, 'agenciaCombo', agencia)
        this.$set(this.model, 'agenciaText', agenciaText)
      } else {
        this.$set(this.model, 'agenciaCombo', null)
        this.$set(this.model, 'agenciaText', null)
      }
    },
    'model.tipoQRCode': function (val){
      if (val) {
        let tipo = this.$api.Arrays.TipoQRCodeDinamico.find(x => x.value === val.value)
        this.$set(this.model, 'tipoQRCode', tipo)
      } else {
        this.$set(this.model, 'tipoQRCode', null)
      }
    }
  },
  created () {
    this.pesquisaConta = _.debounce(this.loadComboContas, 300)
  },
  methods: {
    getModelCorrentista () {
      return this.modelCorrentista
    },
    loadComboOperacoes () {
      let th = this
      let dto = {}
      if(th.operacoesRecorrente){
        dto = {
            parameters: [
              { name: "recorrente", value: th.operacoesRecorrente },
              { name: "tipoBuscaOperacao", value: 2 },
            ],
          };
      }
      th.$api.Operacoes.GetAll(dto).then(function (response) {
        th.loadComboBancos()
        th.operacoes = []
        th.$set(th.model, 'operacao', null)
        if (th.$api.UI.PostLoadData(response)) {
          response.forEach(function (item) {
            let operacao = {
              value: item.codigo,
              text: item.identificador + ' - ' + item.descricao
            }
            th.operacoes.push(operacao)
          })
        }
      })
    },
    loadComboAgencias (parceiro) {
      this.$set(this.model, 'agencia', null)
      this.$set(this.model, 'conta', null)

      if (!parceiro) return
      let th = this

      let dto = {
        parameters: [
          { name: 'codigoBanco', value: th.model.banco },
          { name: 'codigoParceiro', value: parceiro }
        ]
      }

      th.$api.Agencias.GetAll(dto).then(function (data) {
        th.agencias = []
        th.$set(th.model, 'agencia', null)
        if (th.$api.UI.PostLoadData(data)) {
          if (!data.length || data.length === 0) {
            th.$api.UI.ShowError(
              'Erro',
              'Não existem agências cadastradas para este banco ou parceiro.'
            )
          } else {
            data.forEach(function (item) {
              th.agencias.push({
                value: item.codigo,
                text: item.numero + '-' + item.digito + ' ' + item.nome,
                numero: item.numero,
                digito: item.digito
              })
            })
            if (th.autoSelectAgencia && data[0].numero === "0001" && +data[0].digito === 8) {
              th.$set(th.model, 'agencia', data[0].codigo)
            }
          }
        }
      })
    },
    loadComboBancos () {
      let th = this

      let dto = {}
      th.$api.Bancos.GetBancosInternos(dto).then(function (data) {
        th.bancos = []
        th.$set(th.model, 'banco', null)
        if (th.$api.UI.PostLoadData(data)) {
          data.forEach(function (item) {
            let banco = {
              value: item.codigo,
              text: item.numero + ' - ' + item.descricao
            }
            th.bancos.push(banco)
          })

          th.$set(
            th.model,
            'banco',
            data.find((e) => e.numero === process.env.VUE_APP_BANCO).codigo
          )
        }
      })
    },
    changeAgencia () {
      this.$nextTick(function () {
        this.loadComboContas()
      })
    },
    loadComboContas (conta) {
      let th = this
      if (this.model.agencia || !th.disableConta) {
        if (!conta && th.model.contaCombo) conta = th.model.contaCombo.text
        let dto = {
          parameters: [
            { name: 'codigoAgencia', value: this.model.agencia },
            { name: 'codigoParceiro', value: th.model.parceiro },
            { name: 'situacaoConta', value: th.contaAtivas },
            { name: 'numeroConta', value: conta },
            { name: 'numeroAgencia', value: th.numeroAgenciaDefault }
          ]
        }
        if (!dto) return
        th.$api.Contas.ComboContas(dto).then(function (data) {
          if (data) {
            if (!data.length || data.length === 0) {
              th.$api.UI.ShowError(
                'Erro',
                'Não foram encontradas contas com os parâmetros informados.'
              )
              th.contas = []
            } else {
              let arrayContas = []
              data.forEach(function (item) {
                arrayContas.push({
                  value: item.codigo,
                  text: item.contaPgto,
                  numero: item.numero,
                  digito: item.digito,
                  tipoConta: item.tipoConta,
                  modeloConta: item.modeloConta
                })
              })

              th.$nextTick(function () {
                th.contas = arrayContas
              })
            }
          }
        })
      } else {
        th.$set(this, 'contas', [])
        th.$set(this.model, 'contaCombo', null)
      }
    },
    loadComboParceiros () {
      let th = this
      th.$api.Parceiros.GetAll().then(function (response) {
        th.parceiros = []
        th.$set(th.model, 'parceiro', null)
        if (Array.isArray(response)) {
          if (th.todosParceiros) {
            if (!th.parceiros.find((o) => o.text === 'Todos' && !!o.value)) { th.parceiros.unshift({ value: 0, text: 'Todos' }) }

            th.$set(th.model, 'parceiro', 0)
          }
          response.forEach(function (item) {
            let parceiro = {
              value: item.codigo,
              text: item.nome.concat(
                ' ',
                '(CNPJ: ',
                th.$api.UI.Format.DocumentoFederal(item.documentoFederal),
                ')'
              )
            }

            th.parceiros.push(parceiro)
          })

          if (th.parceiroSelected) {
            th.$set(th.model, 'parceiro', response[0].codigo)
          }
          th.$emit('obteveParceiros', true);
        }
      })
    },
    changeConta (val) {
      let th = this
      this.modelCorrentista.nome = ''
      this.modelCorrentista.documentoFederal = ''
      this.modelCorrentista.tipoPessoa = null

      if (val && val.value && this.showInfoCorrentista) {
        th.$api.ContaCorrentistas.GetCorrentistaTitular(val.value).then(
          function (response) {
            if (th.$api.UI.PostAction(response, '', false)) {
              th.modelCorrentista.nome = response.nome
              th.modelCorrentista.documentoFederal =
                th.$api.UI.Format.DocumentoFederal(response.documentoFederal)
              th.modelCorrentista.tipoPessoa = response.tipoPessoa
              th.modelCorrentista = Object.assign({}, th.modelCorrentista)
            }
          }
        )
      }
    },
    changeParceiro(val) {
      let th = this
      th.$set(th.model, 'contaCombo', null)
    },
    refresh () {
      this.$emit('refresh')
    }
  },
  beforeMount: function () {
    if (this.comboOperacoes) this.loadComboOperacoes()
    else this.loadComboBancos()
  }
}
</script>
